import {useEffect, useState} from 'react'
import {useNavigate, useSearchParams} from 'react-router'
import {setToken} from '../../auth/token-storage.js'
import {useAuth} from '../../auth/use-auth.js'
import styles from './auth.module.scss'

//survives re-mounts (StrictMode double-invoke, route bounces) so a single-use
//activation token is consumed exactly once per page load
let consumedToken = null

export function AuthScreen() {
    const [params, setParams] = useSearchParams()
    const navigate = useNavigate()
    const {status, refresh} = useAuth()
    const [state, setState] = useState('validating')
    const invalidParam = params.get('invalid')

    useEffect(() => {
        //A stale or hand-forged ?invalid=1 must not log out a live session. The provider's
        //backend validation (getMe) is the source of truth, not the URL: just strip the flag
        //and let the status-driven effect below decide. In the genuine-rejection path the
        //token was already cleared before we landed here (client.js 401 handler / route
        //guards), so validation resolves to 'invalid' and we show the activation screen anyway.
        if (invalidParam) {
            const next = new URLSearchParams(params)
            next.delete('invalid')
            setParams(next, {replace: true})
            return
        }
        //consume the activation link once: store the token, strip it from the URL so a
        //re-render/re-mount can't reprocess it, then validate (getMe + status)
        const token = params.get('token')
        if (token) {
            if (token !== consumedToken) {
                consumedToken = token
                setToken(token)
                refresh()
            }
            setParams({}, {replace: true})
        }
    }, [params, invalidParam, refresh, setParams])

    //react to the status resolved by the provider/refresh(); only place that navigates
    useEffect(() => {
        if (status === 'authed')
            navigate('/', {replace: true})
        else if (status === 'invalid')
            setState('invalid')
    }, [status, navigate])

    if (state === 'validating')
        return (
            <div className={styles.center}>
                <div className={styles.spinner} aria-label="Validating session"/>
            </div>
        )

    return (
        <div className={styles.center}>
            <div className={styles.brand}>
                <span className={styles.glyph} aria-hidden="true"/>
                <span className={styles.name}>VerdaSync</span>
            </div>
            <h1 className={styles.title}>Need an activation link</h1>
            <p className={styles.body}>
                This phone isn't paired yet. Ask your admin to send you an activation link or scan
                the QR from the admin console — it'll open the app and sign you in automatically.
            </p>
            <p className={styles.meta}>Already have a link? Open it from your SMS or email.</p>
        </div>
    )
}
